import React, { useState } from 'react';
import logo from '../../assets/logo.jpg';
import Cart from '../Cart/Cart';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import BrandsDropdown from './BrandsDropdown/BrandsDropdown';
import CategoriesDropdown from './CategoriesDropdown/CategoriesDropdown';
import SearchBar from './SearchBar/SearchBar';
import './Topbar.scss';
import { useNavigate } from 'react-router-dom';
import useUserStore from '../../store/userStore'; 
import LoginPopup from '../LoginPopup/LoginPopup'; 
import AccountMenuContext from './AccountMenuContext/AccountMenuContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

export default function Topbar() {
  const navigate = useNavigate();
  const [isLoginPopupOpen, setIsLoginPopupOpen] = useState(false);
  const { user, isAuthenticated, logout } = useUserStore(); 
  const [isMenuOpen, setIsMenuOpen] = useState(false); 
  const openLoginPopup = () => setIsLoginPopupOpen(true); 
  const closeLoginPopup = () => setIsLoginPopupOpen(false); 

  const handleLogout = () => {
    logout(); 
    navigate('/');
  };

  return (
    <div className="topbar">
      <div className="t-col t-col-1">

        <div className="logo" onClick={() => navigate(`/`)}>
          <img src={logo} alt="Logo" />
        </div>
      </div>
      <div className="t-col t-col-2">
        <SearchBar />
        <CategoriesDropdown />
        <BrandsDropdown />

        {isAuthenticated ? (
          <div className="user-info">
            <div
          className="username authenticated-user"
             style={{cursor:'pointer'}} onClick={()=>setIsMenuOpen(true)}>{user?.username} <FontAwesomeIcon icon={faChevronDown} /> </div> 
          
            {isAuthenticated && isMenuOpen && (
        <AccountMenuContext 
          onClose={() => setIsMenuOpen(false)}
          onLogout={handleLogout}
          username={user?.username}
        />
      )}
          </div>
        ) : (
          <div className="b-text" onClick={openLoginPopup}>
            Είσοδος
          </div>
        )}
        <Cart />
        <button className="contact">Επικοινωνία</button>
        {/* <LanguageSwitcher /> */}
      </div>

      {isLoginPopupOpen && <LoginPopup onClose={closeLoginPopup} />}
     
    </div>
  );
}